const typesStageSubPhase = {
    description: 'description',
    descriptionCustDev: 'descriptionCustDev',
    descriptionIterDev: 'descriptionIterDev',
    whyNeeded: 'whyNeeded',
    hasStageAffectsProduct: 'hasStageAffectsProduct',
    whatResultStage: 'whatResultStage',
};

export const trlsKeyStageSubPhase = {
    [typesStageSubPhase.description]: 'Об этапе',
    [typesStageSubPhase.descriptionCustDev]: 'CustDev',
    [typesStageSubPhase.descriptionIterDev]: 'Итерационная разработка',
    [typesStageSubPhase.whyNeeded]: 'Зачем нужен',
    [typesStageSubPhase.hasStageAffectsProduct]: 'Как влияет на продукт',
    [typesStageSubPhase.whatResultStage]: 'Результаты этапа',
};

export default typesStageSubPhase;
